import { makeAutoObservable, runInAction } from "mobx";
import { makePersistable } from "mobx-persist-store";

export default class BillsStore {
  constructor() {
    makeAutoObservable(this);
    makePersistable(this, {
      name: "BillsStore",
      properties: [
        "",
        "allBillsTotalCount",
        "billsAnalysis",
        "billsToReconcile",
        "selectedBill",
      ],
    });
  }

  allBills = [];
  billsAnalysis = [];
  billsToReconcile = {};
  selectedBill = {};

  reset = () => {
    this.allBills = [];
    this.billsAnalysis = [];
    this.billsToReconcile = {};
    this.selectedBill = {};
  };

  setBills = async (bills) => {
    runInAction(() => {
      this.allBills = bills;
    });
  };

  setBillsAnalysis = async (data) => {
    runInAction(() => {
      this.billsAnalysis = data;
    });
  };

  setBillsToReconcile = async (data) => {
    runInAction(() => {
      this.billsToReconcile = data;
    });
  };
  setSelectedBill = async (data) => {
    runInAction(() => {
      this.selectedBill = data;
    });
  };
}
